import { client } from './setup';
import { BOOKNG_RULES_API } from '../globals';

export default {
    getRules: (id) => client.get(`${BOOKNG_RULES_API}/${id}`),
    createContentRules: (id, rules) => client.post(`${BOOKNG_RULES_API}/${id}`, rules),
    editContentRules: (id, rules) => client.post(`${BOOKNG_RULES_API}/${id}`, rules),
    deleteRule: (id) => client.delete(`${BOOKNG_RULES_API}/${id}`),
}